import { Component, OnInit, ViewChild, ElementRef, TemplateRef } from '@angular/core';
import { sla, kpiRelease, quater, year, kpi, slaIssueList } from './../../../models/slakpi';
import { division } from './../../../models/admin';
import { UtilityService } from './../../../services/utility.service';
import { SLAKPIApiService } from './../../../services/slakpi.service';
import { AdminApiService } from './../../../services/admin.service';
import { UserService } from './../../../services/user.service';
import { SpinnerVisibilityService } from 'ng-http-loader';
import Swal from 'sweetalert2';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { KPIInfoComponent } from './../../../component/slakpi/kpi-info/kpi-info.component';
import {
  AngularGridInstance,
  Column,
  FieldType,
  Filters,
  Formatter,
  GridOption,
  FileType,
  Formatters,
  OnEventArgs,
  MenuCallbackArgs,

} from 'angular-slickgrid';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ToasterService } from '../../../toaster.service';
@Component({
  selector: 'app-slaissue-list.component',
  templateUrl: './slaissue-list.component.html',
  styleUrls: ['./slaissue-list.component.css']

})
export class SLAIssueListComponent implements OnInit {
  //Global Variables
  public sli_data: any;
  public slaIssuelist_data: any;
  public issueComment_data_hostory: any = [];
  public txtIssueInfo: string = '';
  public yearData: any;
  public quaterData: any;
  public division_data: any;
  public frequency_data: any;
  public resettype_data: any;
  public slaUno?: number;
  public yearUno?: number;
  public quarterUno?: number;
  public divisionUno?: number;
  public frequencyUno?: number;
  public historyStartIndex: number = 1;
  public historyMaxCount: number = 100;
  historydisableMore: boolean = true;
  public objkpiRelease: kpiRelease;
  public kpinameSelected: string = '';
  public pageSettings_Justfication: Object;
  public toolbar_Justfication: Object;
  public isback: boolean = false;
  columnDefinitions: Column[];
  gridOptions: GridOption;
  public loading: boolean = true;
  angularGrid: AngularGridInstance;
  dataset: any;
  gridOptionsHistory: GridOption;
  columnCommentDefinitions: Column[];
  cmtsGrid: AngularGridInstance;
  datasetComments: any;
  issueGrid: AngularGridInstance;
  datasetIssues: any;
  columnIssueDefinitions: Column[];
  modalRef: BsModalRef;
  //Syncfusion Control Values

  @ViewChild('IssueDialog', { static: false }) IssueDialog: TemplateRef<any>;
  @ViewChild('IssueCommentDialog', { static: false }) IssueCommentDialog: TemplateRef<any>;
  public filterSettings: Object;
  public toolbar: string[];
  public pageSettings: Object;
  public formatoptions: Object;

  public issuetype_data: any;
  public issueComment: string = ''; 
  public isResetTypeErr: boolean = false;
  public isCommentErr: boolean = false;
  public resettypeCode: number=0;
  public objkpiIssueUpdate: number;
  public kpiTrnIssueNo: number;
  public kpiTrnUno: number;
  //for Users Default Value
  user: any = {};
  login_UserID: string; // number
  currentYear?: number;
  currentHalf?: number;
  currentQuarter?: number;
  currentMonth?: number;
  isToggle: boolean = false;
  issueStatusupdate: boolean = true;
  //for Users Permission
  public permision_add: boolean = false;
  public permision_edit: boolean = false;
  public permision_delete: boolean = false;
  public permision_resolve: boolean = false;
  public permision_issueUpdate: boolean = false;

  isAdmin: boolean = false;
  public position_comment: object = { X: 200, Y: 230 };
  public position_issuestatus: object = { X: 450, Y: 230 };

  public Qyearsla: number=0;
  public Qquatersla: number=0;
  public Qdivisionsla: number = 0;

  //for KPI All Hisory Dialog

  public kpiUnoSelected: number = 0;
  //public kpinameSelected: string = '';
  @ViewChild('KPIAllHistoryDialog', { static: false }) KPIAllHistoryDialog: TemplateRef<any>;
  public position_history: object = { X: 70, Y: 90 };
  //public wrapSettings: TextWrapSettingsModel;
  public context: any;
    searchText: string;
    dataSearch: any[];
  noDataImg: any;
  tenantUno: any;
    isDigitalDewa: boolean=false;
    selectedJustification: string;
  slaName: any;

  isInternalAudit: boolean = false;
  constructor(public restApi: SLAKPIApiService, private _activatedRoute: ActivatedRoute, private toaster: ToasterService, public adminService: AdminApiService, private userService: UserService, private modalService: BsModalService,
    public utilityService: UtilityService, private router: Router, private spinner: SpinnerVisibilityService, private kpiAllHistoryComponent: KPIInfoComponent) {
    this._activatedRoute.queryParams.subscribe((params: Params) => {
      
      this.Qyearsla = Number(params['yearsla']);
      this.Qquatersla = Number(params['quatersla']);
      this.Qdivisionsla = Number(params['divisionsla']);
      if (this.Qyearsla > 0) this.isback = true;
    });


    //To Validate User Permission
    this.user = this.userService.getUserInfo();
    this.login_UserID = this.user.id;
    this.noDataImg = this.utilityService.getnodataImage();
    this.tenantUno = this.user.tenantUno;
    this.isAdmin = (this.user.role == 'Administrator') ? true : false;
    this.permision_issueUpdate = (this.user.role == 'Administrator' || this.user.role == 'SLA Admin' || this.user.role == 'SLA Coordinator') ? true : false
    if (!this.isAdmin) {
      this.CheckUserPermission();
    }
    else {
      this.permision_add = true;
      this.permision_edit = true;
      this.permision_delete = true;
      this.permision_resolve = true; 
     
    }
 
    //this.wrapSettings = { wrapMode: 'Content' };
  }
  ngOnInit() {
    this.userService.CheckLogin();
    this.user = this.userService.getUserInfo();
    this.login_UserID = this.user.id;
    this.currentYear = this.user.currentYear;
    this.currentHalf = this.user.currentHalf;
    this.currentQuarter = this.user.currentQuarter;
    this.currentMonth = this.user.currentMonth;
    this.yearUno = this.currentYear;
    this.quarterUno = this.currentQuarter;
    this.isDigitalDewa = (this.user.tenantDigitalUser == 'true') ? true : false;
    this.isInternalAudit = (this.user.role == 'Internal Audit') ? true : false;
    this.slaName = this.user.slaname;
    this.objkpiRelease = new kpiRelease();
    this.gridOptions = {
      autoHeight: true,
      enableAutoResize: true,
      enablePagination: true,
      pagination: {
        pageSizes: [5, 10, 20, 50, 100, 500],
        pageSize: 20
      },
      enableFiltering: true,
      alwaysShowVerticalScroll: false,
      enableRowSelection: true,
      autoResize: {
        containerId: 'musherat-grid',
        delay: 0,
        sidePadding: 10,
        bottomPadding: 10
      },
      enableExcelExport: true,
      enableExcelCopyBuffer: true,
      enableFilterTrimWhiteSpace: true,
      showCustomFooter: true, // display some metrics in the bottom custom footer
      enableContextMenu: true,
      enableCellMenu: true,
      forceFitColumns: true,
      enableCheckboxSelector: false,

      multiSelect: false,
      rowSelectionOptions: {
        // True (Single Selection), False (Multiple Selections)
        selectActiveRow: true,
      },

    };

    this.gridOptionsHistory = {
      autoHeight: true,
      enableAutoResize: true,
      enablePagination: true,

      pagination: {
        pageSizes: [5, 10, 20, 50, 100, 500],
        pageSize: 100
      },
      enableFiltering: true,
      alwaysShowVerticalScroll: false,
      enableRowSelection: true,
      autoResize: {
        containerId: 'myTabContent',
        delay: 0,
        sidePadding: 10,
        bottomPadding: 10
      },
      enableExcelExport: true,
      enableExcelCopyBuffer: true,
      enableFilterTrimWhiteSpace: true,
      showCustomFooter: true, // display some metrics in the bottom custom footer
      enableContextMenu: true,
      enableCellMenu: true,
      forceFitColumns: true,

    };

    this.loadFilterValues();
    this.loadFrequency();
    this.loadIssueType();
    this.toolbar = ['Search', 'ExcelExport'];

    this.pageSettings = { pageSize: 20, pageSizes: true };
    this.filterSettings = { type: 'Excel' };
    this.formatoptions = { type: 'date', format: 'dd/MM/yyyy' };
    this.toolbar_Justfication = ['Search'];
    this.pageSettings_Justfication = { pageSize: 5, pageSizes: true };
    // setTimeout(() => { this.ResetDialog.hide(); }, 100);
  }
  //To Validate Current User - Page Level Permission
  CheckUserPermission() {

    let userPermissionData = this.userService.getUserRights("SLA Issue List");
    if (userPermissionData != null && userPermissionData != undefined && userPermissionData.length > 0) {
      if (userPermissionData[0].showPage == 1) {
        this.permision_add = (userPermissionData[0].showAdd == 1) ? true : false;
        this.permision_edit = (userPermissionData[0].showEdit == 1) ? true : false;
        this.permision_delete = (userPermissionData[0].showDelete == 1) ? true : false;
        
        //User rights

        let userPermissionDataRelease = this.userService.getUserRights("Resolve Issue");
        if (userPermissionDataRelease != null && userPermissionDataRelease != undefined && userPermissionDataRelease.length > 0) {
          if (userPermissionDataRelease[0].showPage == 1) {
            this.permision_resolve = true;
          }
          else
            this.permision_resolve = false;
        }

        if (this.user.role == 'SLA Admin')
          this.permision_resolve = true;

      }
      else {
        this.router.navigateByUrl('/access-denied');
      }
    }
    else {
      this.router.navigateByUrl('/access-denied');
    }
  }
  viewKPIHistoryAll(kpiUno: any, kpiNameEn: any) {
    this.kpiUnoSelected = kpiUno;
    this.kpinameSelected = kpiNameEn;
    this.kpiAllHistoryComponent.viewKPI(kpiUno);
 
    this.modalRef = this.modalService.show(
      this.KPIAllHistoryDialog,
      Object.assign({}, {
        class: 'gray modal-lg',
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: true,
        animated: true
      })
    );
  }

  //Load Frequency Values
  loadFilterValues() {
    this.spinner.show();
    let inpValue = new year();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    this.restApi.getKPITranFilterValues(inpValue)
      .subscribe(data => {
        
        let objdata: any = data;
        this.sli_data = objdata.list_SLAMaster;
        this.division_data = objdata.list_DivisionMaster;
        this.quaterData = objdata.list_QuarterMaster;
        this.yearData = objdata.list_YearMaster;

        setTimeout(() => {
          this.yearUno = (this.Qyearsla > 0) ? this.Qyearsla : Number(this.yearUno);
          this.quarterUno = (this.Qquatersla > 0) ? this.Qquatersla : Number(this.quarterUno);
          if (this.Qdivisionsla > 0) {
            this.divisionUno = Number(this.Qdivisionsla);
          }
       
          this.loadSlaIssueList(2); //by filter

        }, 30);

        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });

  }

  // Get sla list
  loadSLA() {
    this.spinner.show();
    let inpValue = new sla();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;

    this.restApi.getSLAs(inpValue)
      .subscribe(data => {
        
        this.sli_data = data;
      
        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }
  // Get Year / Quater
  loadYear() {

    let inpValue = new year();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 0;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    
    this.restApi.getYearMaster(inpValue)
      .subscribe(data => {
        
        this.yearData = data;

        setTimeout(() => {
          this.yearUno = (this.Qyearsla > 0) ? this.Qyearsla : Number(this.yearUno);
        }, 10);

      },
        (error) => {
          //Called when error

        }
      ).add(() => {
        //Called when operation is complete (both success and error)

      });
  }
  loadQuater() {

    let inpValue = new quater();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 0;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    
    this.restApi.getQuaterMaster(inpValue)
      .subscribe(data => {
        
        this.quaterData = data;
        setTimeout(() => {
          
          this.quarterUno = (this.Qquatersla > 0) ? this.Qquatersla : Number(this.quarterUno);
          this.loadSlaIssueList(2); //by filter
        }, 10);
        

      },
        (error) => {
          //Called when error
          this.loadSlaIssueList(2); //by filter
        }
      ).add(() => {
        //Called when operation is complete (both success and error)

      });
  }

  loadDivisions() {

    let inpValue = new division();
    inpValue.userUno = this.login_UserID;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    this.restApi.getDivisions(inpValue)
      .subscribe(data => {
        
        this.division_data = data;

        if (this.Qdivisionsla > 0)
          setTimeout(() => {
            this.divisionUno = Number(this.Qdivisionsla);
          }, 10);

      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }


  loadFrequency() {
    if (this.isDigitalDewa == false) {
      this.frequency_data = [];
      this.frequency_data = [
        { frequencyCode: 1, frequencyName: 'Yearly' },
        { frequencyCode: 2, frequencyName: 'Semi-annually' },
        { frequencyCode: 3, frequencyName: 'Quarterly' }
        //{ frequencyCode: 4, frequencyName: 'Monthly' }
      ];
    }

    if (this.isDigitalDewa == true || this.tenantUno == 5) {
      this.frequency_data = [];
      this.frequency_data = [
        { frequencyCode: 1, frequencyName: 'Yearly' },
        { frequencyCode: 2, frequencyName: 'Semi-annually' },
        { frequencyCode: 3, frequencyName: 'Quarterly' },
        { frequencyCode: 4, frequencyName: 'Monthly' }
      ];
    }
  }
  loadIssueType() {
    this.issuetype_data = [
      { issuetypeCode: 1, issuetypeName: 'Open' },
      { issuetypeCode: 2, issuetypeName: 'In progress' },
      { issuetypeCode: 3, issuetypeName: 'Resolved' },
      { issuetypeCode: 4, issuetypeName: 'Closed' },
      { issuetypeCode: 5, issuetypeName: 'Cancelled' }
    ];
  }
  onchangeIssueType(e) {
    
    this.resettypeCode = (e && e.length > 0 && e[0].value != 'All') ? e[0].value : '' ;
    if (this.resettypeCode == 0) {
      this.isResetTypeErr = true;
    }
    else
    this.isResetTypeErr = false;
    // this.onSelectedTab();
  }
  showIssueDialog(data: any,isseDesc:any, type:any) {
  
    this.modalRef = this.modalService.show(
      this.IssueDialog,
      Object.assign({}, {
        class: 'gray modal-medium',
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: true,
        animated: true
      })
    );
    this.txtIssueInfo = isseDesc;
    
    this.kpiTrnIssueNo = data.kpiTrnIssueUno;
    this.kpiTrnUno = data.kpiTrnUno;
    this.kpinameSelected = data.kpiName;
    this.isCommentErr = false;
    this.issueComment = isseDesc;
    if (type == 'updatestatus')
      this.issueStatusupdate = true;
    else
      this.issueStatusupdate = false;
  }
  showIssueCommentDialog(data: any) {
  
    this.modalRef = this.modalService.show(
      this.IssueCommentDialog,
      Object.assign({}, {
        class: 'gray modal-xl',
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: true,
        animated: true
      })
    );
    //this.issueComment_data = [];
    this.kpinameSelected = data.kpiName;
    this.selectedJustification = data.issueDescription;
    this.loadIssueCommentHistory(data.kpiTrnIssueUno, true);
  }
  //Get KPI History
  loadIssueCommentHistory(kpiTrnIssueUno: number, isStart) {
    this.spinner.show();
    let inpValue = new slaIssueList();
    inpValue.kpiTrnIssueUno = kpiTrnIssueUno;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;;
    this.historyStartIndex = (this.historyStartIndex == undefined || this.historyStartIndex < 1 || isStart) ? 1 : this.historyStartIndex;
    inpValue.startIndex = this.historyStartIndex;
    inpValue.maxCount = this.historyMaxCount;

    this.restApi.getkpiIssueComment(inpValue)
      .subscribe(data => {
        
        let objData: any = data;

        if (this.historyStartIndex == 1) {
          this.issueComment_data_hostory = [];
          this.issueComment_data_hostory = objData;
        }
        else {
          for (var i = 0; i < objData.length; i++) {
            this.issueComment_data_hostory.push(objData[i]);
          }
        }

        const mockDataset = [];
        for (let i = 0; i < this.issueComment_data_hostory.length; i++) {
          mockDataset[i] = {
            id: i + 1,
            action: this.issueComment_data_hostory[i].action,
            postedBy: this.issueComment_data_hostory[i].postedBy,
            postedDate: this.issueComment_data_hostory[i].postedDate,
            comment: this.issueComment_data_hostory[i].comment,
          };
        }
        this.datasetComments = mockDataset;
        this.setCommentDefn();
        //if the result set is lessthen 10 then disable the load more icon
        this.historydisableMore = (objData.length >= 100) ? false : true;
        if (objData.length > 0) {
          //this.ifcountgreaterthanzero = true;
          this.historyStartIndex = this.historyStartIndex + 1;
        }


        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }


  AddKPIIssueFormSubmit() {
    
    if (this.resettypeCode == 0) {
      this.isResetTypeErr = true;
      return false;
    }
    else
      this.isResetTypeErr = false;

    if (this.issueComment == '') {
      //Swal.fire('Error', 'Please enter comment', 'error')
      this.isCommentErr = true;
      return false;
    }

    if (this.objkpiIssueUpdate <= 0) {
      //Swal.fire('Error', 'KPI update action is not selected ', 'warning');
      this.isResetTypeErr = true;
      return false;
    }
    else {
     
      Swal.fire({
        title: '',
        text: 'Please confirm to update',
        type: 'info',
        showCancelButton: true,
        confirmButtonText: 'Ok',
        cancelButtonText: 'Cancel'
      }).then((result) => {
        if (result.value) {
          this.modalRef.hide();
          this.onSubmitIssue();
          this.isResetTypeErr = false;
          this.isCommentErr = false;
          return;
        } else if (result.dismiss === Swal.DismissReason.cancel) {

          return;
        }
      }) 
    }
    return true;

  }

  AddKPIIssueDescriptionSubmit() {
    
     
    if (this.issueComment == '') {
      //Swal.fire('Error', 'Please enter comment', 'error')
      this.isCommentErr = true;
      return false;
    }
     

      Swal.fire({
        title: '',
        text: 'Please confirm to update',
        type: 'info',
        showCancelButton: true,
        confirmButtonText: 'Ok',
        cancelButtonText: 'Cancel'
      }).then((result) => {
        if (result.value) {
          this.modalRef.hide();
          this.onSubmitIssueDesc();
          this.issueComment = '';
          this.isCommentErr = false;
          return;
        } else if (result.dismiss === Swal.DismissReason.cancel) {

          return;
        }
      })
    
    return true;

  }

  onSubmitIssue() {
   

    let objKPIView = new slaIssueList();
    objKPIView.kpiUno = 0;
    objKPIView.kpiTrnIssueUno = this.kpiTrnIssueNo;   
    objKPIView.issueDescription = this.issueComment;
    objKPIView.issueStatusUno = this.resettypeCode;
    objKPIView.userUno = this.login_UserID;
    objKPIView.tenantUno = this.tenantUno;
    
    this.spinner.show();
    this.restApi.updateKpiIssue(objKPIView)
      .subscribe(data => {
        
        if (data != null && data != undefined && data != '') {
          //Swal.fire('Error', 'Something went wrong', 'error')
          this.toaster.show('error', 'Error', 'Something went wrong.');
        }
        else {
          this.toaster.show('success', 'Success', 'KPI Updated.');
          //Swal.fire({
          //  type: 'success',
          //  title: 'KPI Updated',
          //  showConfirmButton: false,
          //  timer: 1500
          //})
          this.loadSlaIssueList(2); 

        }


        this.spinner.hide();
        
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
    return true;
  }
  onSubmitIssueDesc() {


    let objKPIView = new slaIssueList();
    objKPIView.kpiUno = 0;
    objKPIView.kpiTrnUno = this.kpiTrnUno;
    objKPIView.issueDescription = this.issueComment;
    
    objKPIView.userUno = this.login_UserID;
    objKPIView.tenantUno = this.tenantUno;
    
    this.spinner.show();
    this.restApi.updateKpiIssueDescription(objKPIView)
      .subscribe(data => {
        
        if (data != null && data != undefined && data != '') {
         // Swal.fire('Error', 'Something went wrong', 'error')
          this.toaster.show('error', 'Error', 'Something went wrong.');
        }
        else {
          this.toaster.show('success', 'Success', 'KPI Updated');
          //Swal.fire({
          //  type: 'success',
          //  title: 'KPI Updated',
          //  showConfirmButton: false,
          //  timer: 1500
          //})
          this.loadSlaIssueList(2);

        }


        this.spinner.hide();

      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
    return true;
  }

  // Get SlaIssueList list
  loadSlaIssueList(condition) {
    
    this.loading = true;
    let inpValue = new slaIssueList();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = condition;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    inpValue.slaUno = this.slaUno ? this.slaUno:0;
    inpValue.kpiyear = this.yearUno ? this.yearUno : 0;
    inpValue.kpiquarter = this.quarterUno ? this.quarterUno : 0;
    inpValue.divisionUno = this.divisionUno ? this.divisionUno : 0;
    inpValue.frequencyUno = this.frequencyUno ? this.frequencyUno : 0;
    inpValue.half = this.currentHalf;
    inpValue.month = this.currentMonth;
    this.restApi.getSlaIssueList(inpValue)
      .subscribe(data => {
        
        this.slaIssuelist_data = data;
        const mockDataset = [];
        for (let i = 0; i < this.slaIssuelist_data.length; i++) {
          mockDataset[i] = {
            id: i + 1,
            kpiCode: this.slaIssuelist_data[i].kpiCode,
            kpiName: this.slaIssuelist_data[i].kpiName,
            periodDisplay: this.slaIssuelist_data[i].periodDisplay,
            issueDescription: this.slaIssuelist_data[i].issueDescription,
            issueStatus: this.slaIssuelist_data[i].issueStatus,
            kpiUno: this.slaIssuelist_data[i].kpiUno,
            kpiTrnIssueUno: this.slaIssuelist_data[i].kpiTrnIssueUno,
            bandColour: this.slaIssuelist_data[i].bandValue,
            kpiTrnUno: this.slaIssuelist_data[i].kpiTrnUno,
          };
        }
        this.dataset = mockDataset;
        this.dataSearch = mockDataset;
        if (mockDataset.length > 0) {
          this.setColnDefn();
        }
        this.loading = false;
       
      },
        (error) => {
          //Called when error
          this.loading = false;
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }

  drawertoggle() {
    
    this.isToggle = (this.isToggle) ? false : true;
  }

  // Choose city using select dropdown
  onchangeSLA(e) {
    
    //alert(e.itemData.slaUno);
    this.slaUno = (e && e.length > 0) ? e[0].value : 0;
    this.onSelectedTab();

  }
  onchangeYear(e) {
    
    this.yearUno = (e && e.length > 0) ? e[0].value : 0;
    this.onSelectedTab();
  }


  onchangeQuarter(e) {
    this.quarterUno = (e && e.length > 0) ? e[0].value : 0;
    this.onSelectedTab();
  }


  onchangeDivision(e) {
    this.divisionUno = (e && e.length > 0) ? e[0].value : 0;
    this.onSelectedTab();
  }


  onchangeFrequency(e) {
    this.frequencyUno = (e && e.length > 0 && e[0].value != 'All') ? e[0].value : 0; 
    this.onSelectedTab();
  }


  onSelectedTab() {
    this.loadSlaIssueList(2); //by filter
  }



  backClick() {
    this.router.navigate(['/sladashboard/report'], { queryParams: { yearsla: this.yearUno, quatersla: this.quarterUno, divisionsla: this.divisionUno } });

  }

  uniqueArray(arrayList, val, label) {
    var temp = this;
    var aList = [];
    if (arrayList) {
      for (var i = 0, l = arrayList.length; i < l; i++)
        if (aList.filter(item => item.label == temp.Checklabel(arrayList[i][label])).length == 0) {

          aList.push({
            'value': this.CheckValue(arrayList[i][val]), 'label': this.Checklabel(arrayList[i][label])
          });
        }
    }


    aList.sort((a: any, b: any) => {
      if (a['value'] < b['value']) {
        return -1;
      } else if (a['value'] > b['value']) {
        return 1;
      } else {
        return 0;
      }
    });
    return aList;
  }

  exportToExcel() {
    var temp = this;
    setTimeout(function () {
      temp.angularGrid.excelExportService.exportToExcel({
        filename: 'Export',
        format: FileType.xlsx,

      });
    }, 100)


  }

  exportToExcelIssue() {
    var temp = this;
    setTimeout(function () {
      temp.issueGrid.excelExportService.exportToExcel({
        filename: 'Export',
        format: FileType.xlsx,

      });
    }, 100)


  }

  exportToExcelCmt() {
    var temp = this;
    setTimeout(function () {
      temp.cmtsGrid.excelExportService.exportToExcel({
        filename: 'Export',
        format: FileType.xlsx,

      });
    }, 100)


  }

  Checklabel(val) {
    if (val != undefined && val != null && val != '' && val != ' ')
      return val.trim();
    else
      return ''

  }

  CheckValue(val) {
    if (val != undefined && val != null && val != '' && val != ':')
      return val;
    else
      return ' '

  }

  IsNull(val) {
    if (val != undefined && val != null && val != '') {
      val = val.trim()
      return val.charAt(0).toUpperCase() + val.slice(1);
    }
    else
      return ' '

  }
  searchGrid() {
    
    if (this.searchText != "") {
      this.dataset = this.dataSearch.filter(a =>
        a.kpiCode && a.kpiCode.toLowerCase().includes(this.searchText.toLowerCase())
        || (a.kpiName && a.kpiName.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.periodDisplay && a.periodDisplay.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.issueDescription && a.issueDescription.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.bandValueText && a.bandValueText.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.issueStatus && a.issueStatus.toLowerCase().includes(this.searchText.toLowerCase())));
    }
    else
      this.dataset = this.dataSearch;
  }

  setColnDefn() {
    let temp = this;
    this.columnDefinitions = [
      {
        id: 'kpiCode', name: 'KPI Code', field: 'kpiCode', sortable: true,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'kpiCode', 'kpiCode'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'kpiName', name: 'KPI', field: 'kpiName', sortable: true, width: 250,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'kpiName', 'kpiName'),
          model: Filters.multipleSelect,
        }
      },
   
      {
        id: 'periodDisplay', name: 'Period', field: 'periodDisplay', sortable: true, type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'periodDisplay', 'periodDisplay'),
          model: Filters.multipleSelect,

        }
      },

      {
        id: 'issueDescription', name: 'Issue Description', field: 'issueDescription', sortable: true, type: FieldType.string, filterable: true, width: 250,
        filter: {
          collection: this.uniqueArray(this.dataset, 'issueDescription', 'issueDescription'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'bandColour', name: 'Performance', field: 'bandColour', sortable: true, type: FieldType.string, filterable: true, formatter: this.bandFormatter,
        filter: {
          collection: this.uniqueArray(this.dataset, 'bandColour', 'bandColour'),
          model: Filters.multipleSelect,
        },

      },
      {
        id: 'issueStatus', name: 'Status', field: 'issueStatus', sortable: true, type: FieldType.string, filterable: true, 
        filter: {
          collection: this.uniqueArray(this.dataset, 'issueStatus', 'issueStatus'),
          model: Filters.multipleSelect,
        },

      },
      
      {
        id: 'action', name: 'Action', field: 'action', cssClass: 'blue', width: 50,
        excludeFromExport: true,
        formatter: this.actionFormatter,
        cellMenu: {
          hideCloseButton: false,
          commandTitleKey: 'COMMANDS',
          commandItems: [
            {
              command: 'Resolve-row', titleKey: 'Resolve_ROW', positionOrder: 60, title: 'Resolve Issue',
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;
                if (this.isInternalAudit)
                  return false;
                else {

                  if ((data.issueStatus != 'Resolved' && data.issueStatus != 'Closed' && data.issueStatus != 'Cancelled' && this.permision_resolve))
                    return true;
                  else false;
                }
              },
              iconCssClass: 'fa fa-circle-o-notch fa-lg ', cssClass: 'blue', textCssClass: 'bold',
              action: (e, args) => {
                let data = args.dataContext;
                this.showIssueDialog(data, data.issueDescription, 'updatestatus')
              }
            },


            {
              command: 'Update-row', titleKey: 'Update_ROW', positionOrder: 61, title: 'Issue Update',
              iconCssClass: 'fa fa-edit fa-lg ', cssClass: 'blue', textCssClass: 'bold',
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;
                if (this.isInternalAudit)
                  return false;
                else {
                  if (data.issueStatus != 'Resolved' && data.issueStatus != 'Closed' && data.issueStatus != 'Cancelled' && this.permision_issueUpdate)
                    return true;
                  else false;
                }
              },
              action: (e, args) => {
                let data = args.dataContext;
                this.showIssueDialog(data, data.issueDescription, 'updatedescription')
              }
            },

            {
              command: 'Log-row', titleKey: 'Log_ROW', positionOrder: 64, title: 'Issue Log',
              iconCssClass: 'fa fa-history fa-lg orange-text  Blink ', textCssClass: 'bold',
              
              action: (e, args) => {
                let data = args.dataContext;
                this.showIssueCommentDialog(data)
              },
            },


            {
              command: 'Info-row', titleKey: 'Info_ROW', positionOrder: 65, title: 'KPI Info',
              iconCssClass: 'fa fa-info-circle fa-lg ', cssClass: 'red', textCssClass: 'bold',
             
              action: (e, args) => {
                let data = args.dataContext;
                this.viewKPIHistoryAll(data.kpiUno,data.kpiName);
              }
            },


          ],
        }
      }
    ]


  }

  actualFormatter: Formatter = (row, cell, value, columnDef, data) => {

    if (data.bandColour != '' && data.dataOwnerActionBy != '' && data.slaRuleUno != 4)
      return data.targetValue;
    if ((data.bandColour != '' && data.dataOwnerActionBy != '' && data.slaRuleUno == 4))
      return data.bandColour == 'Green' ? 'Pass' : 'Fail';
    if (data.bandColour == '' && data.dataOwnerActionBy != '' && data.dataOwnerActionBy != null && (data.isNANRNT != null && data.isNANRNT != ''))
      return data.isNANRNT;
    if ((data.dataOwnerExists == 1 || this.isAdmin) && data.bandColour == '' && data.dataOwnerActionBy == '' && (data.isNANRNT == '' || data.isNANRNT == null)) {
      return '<a matTooltipClass="my-custom-tooltip-avg" title="Data Entry"  class="bcopy-btn" style="cursor:pointer !important;">-</a>'
    }
    if (data.bandColour == '' && data.dataOwnerActionBy != '' && data.isNANRNT != '')
      return '<a  style="text-decoration:underline; cursor:pointer;" >' + data.isNANRNT + '</a>';



  };

  bandFormatter: Formatter = (row, cell, value, columnDef, data) => {
    
    //if (data.slaRuleUno != 1 && data.slaRuleUno != 2 && data.bandColour == '' && (data.isNANRNT != null && data.isNANRNT != ''))
    //  return `<div class="bg-grey-progress" > <span class="bluedark-bar"></span></div>`;
    //if (data.bandColour == '' && (data.slaRuleUno == 1 || data.slaRuleUno == 2) && (data.isNANRNT == 'NA' || data.isNANRNT == 'ND' || data.isNANRNT == 'NR'))
    //  return `<div class="bg-grey-progress" > <span class="bluedark-bar"></span></div>`;
    if (data.bandColour == 'Red')
      return `<div class="bg-grey-progress" > <span class="red-bar"></span></div>`;
    if (data.bandColour == 'Orange')
      return `<div class="bg-grey-progress" > <span class="orange-bar"></span></div>`;
    if (data.bandColour == 'Yellow')
      return `<div class="bg-grey-progress" > <span class="yellow-bar"></span></div>`;
    if (data.bandColour == 'Light Green')
      return `<div class="bg-grey-progress" > <span class="light-green-bar"></span></div>`;
    if (data.bandColour == 'Green')
      return `<div class="bg-grey-progress" > <span class="green-bar"></span></div>`;

  };

  actionFormatter: Formatter = (row, cell, value, columnDef, dataContext) => {
    return `<div class="fake-hyperlink"> <i class="fa fa-ellipsis-h fa-lg"></i></div>`;
  };

  angularGridReady(angularGrid: AngularGridInstance) {
    this.angularGrid = angularGrid;
   // angularGrid
    this.userService.angularGrid = angularGrid;
  }

  cmtsGridReady(angularGrid: AngularGridInstance) {
    this.cmtsGrid = angularGrid;
  }


  setCommentDefn() {
    this.columnCommentDefinitions = [
      { id: 'comment', name: 'Comment', field: 'comment', sortable: true },
      { id: 'postedBy', name: 'Created By', field: 'postedBy', sortable: true },
      { id: 'postedDate', name: 'Created Date', field: 'postedDate', sortable: true },
     

    ];
  }

 

}


